import AsyncSelect from "react-select/async"
import cx from "classnames"
import {useTranslation} from "react-i18next"
import {dropdownStyle} from "./dropdownStyle"

type SelectComponentsProps = {[key in string]: any}

export type KlassDropdownAsyncProps = SelectComponentsProps & {
    options?: any[]
    value?: any
    onChange?: any
    placeholder?: string
    valueKey?: string
    labelKey?: string
    hasEmptyOption?: boolean
    readOnly?: boolean
    isMulti?: boolean
    stylesCustom?: any
    checkRemoveButton?: boolean
    closeMenuOnSelect?: boolean
    refData?: any
    cacheOptions?: boolean
    loadOptions?: (search: string, loadedOptions: any) => any
}

export function KlassDropdownAsync(props: KlassDropdownAsyncProps) {
    const {t} = useTranslation(["common"])
    const {
        stylesCustom,
        valueKey,
        labelKey,
        isMulti,
        isDisabled = false,
        readOnly = false,
        isClearable = false,
        className,
        refData,
        cacheOptions = true,
        ...rest
    } = props
    let valueKeySelect = valueKey || "id"
    let labelKeySelect = labelKey || "name"
    let styles = dropdownStyle
    if (stylesCustom) styles = {...styles, ...stylesCustom}
    const customProps = {...rest, styles}

    return (
        <AsyncSelect
            cacheOptions={cacheOptions}
            defaultOptions
            noOptionsMessage={({inputValue}) =>
                !inputValue ? t("selectField.searchAndSelect") : t("selectField.noData")
            }
            getOptionValue={(option: any) => option[valueKeySelect]}
            getOptionLabel={(option: any) => option[labelKeySelect]}
            closeMenuOnSelect
            isMulti={isMulti}
            menuIsOpen={readOnly ? false : undefined}
            isDisabled={isDisabled}
            isSearchable={!readOnly}
            isClearable={isClearable && !readOnly}
            classNamePrefix="klassapp-dropdown"
            className={cx("klassapp-dropdown", className, {readOnly})}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            ref={refData}
            {...customProps}
        />
    )
}
